/* eslint-disable react/destructuring-assignment */
import { ColumnsType } from "antd/es/table";
import { Badge, Tooltip, Typography } from "antd";
import { Employee } from "../../../interfaces/employee.interface";
import { formatFromThai } from "../../../libs/moment";

const defaultTextRender = (value: string) => {
  return (
    <Tooltip title={value}>
      <Typography.Text>{value}</Typography.Text>
    </Tooltip>
  );
};

const generateColumns = (): ColumnsType<Employee> => {
  const columns: ColumnsType<Employee> = [
    // {
    //   title: "LINE UID",
    //   dataIndex: "lineUserId",
    //   key: "lineUserId",
    //   render: defaultTextRender,
    // },
    {
      title: "Name",
      dataIndex: "fullName",
      key: "fullName",
      render: defaultTextRender,
      width: "150px",
    },
    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      render: defaultTextRender,
      width: "180px",
    },
    {
      title: "ประเภทพนักงาน",
      dataIndex: "employeeType",
      key: "employeeType",
      render(value: string) {
        if (value === "permanent") {
          return "พนักงานประจำ";
        }
        if (value === "retire") {
          return "เกษียณ";
        }
        return null;
      },
      width: "180px",
    },
    {
      title: "รหัสพนักงาน",
      dataIndex: "employeeId",
      key: "employeeId",
      render: defaultTextRender,
      width: "160px",
    },
    {
      title: "แผนก",
      dataIndex: "department",
      key: "department",
      render: defaultTextRender,
      width: "160px",
    },
    {
      title: "เบอร์โทรศัพท์",
      dataIndex: "telephone",
      key: "telephone",
      width: "120px",
      render: defaultTextRender,
    },
    {
      title: "LINE ID",
      dataIndex: "lineId",
      key: "lineId",
      width: "150px",
      render: defaultTextRender,
    },
    {
      title: "Status",
      dataIndex: "confirmed",
      key: "confirmed",
      width: "100px",
      render(value: boolean) {
        return (
          <>
            <Badge
              style={{
                display: value === true ? "block" : "none",
              }}
              status="success"
              text="active"
            />
            <Badge
              style={{
                display: value === false ? "block" : "none",
              }}
              status="error"
              text="Inactive"
            />
          </>
        );
      },
    },
    {
      title: "Create Date",
      dataIndex: "created_at",
      key: "created_at",
      width: "160px",
      render(value: string) {
        if (value) {
          return defaultTextRender(formatFromThai(value));
        }
        return null;
      },
    },
    {
      title: "Last Login",
      dataIndex: "updated_at",
      key: "updated_at",
      width: "160px",
      render(value: string) {
        if (value) {
          return defaultTextRender(formatFromThai(value));
        }
        return null;
      },
    },
  ];

  return columns;
};

export default generateColumns;
